import { Link } from "react-router-dom";

const GUIDELINES_PATH = "/help/community-guidelines";

export default function CommunityGuidelinesLink({ className = "" }) {
  return (
    <Link
      to={GUIDELINES_PATH}
      className={`inline-block text-lz-ember hover:text-lz-ink-mid dark:text-white/90 dark:hover:text-white text-base underline ${className}`}
    >
      Community Section Use and Guidelines
    </Link>
  );
}
